export const Site_Vars = {
  default_currency: "£",
}
